import { Injectable } from "@angular/core";
import { RoomContextId } from "@common/domain";
import { v4 as uuid } from "uuid";

@Injectable()
export class RoomContextFacade {
  readonly roomContextId = this.roomContextIdCreate();

  private roomContextIdCreate(): RoomContextId {
    return uuid() as RoomContextId;
  }
}
